import CreateParticles from "./CreateParticles";
import * as THREE from 'three'
export default class Environment {

    constructor( font, particle, message ){ 
        
      this.font = font;
      this.message = message
      this.particle = particle;
      this.container = document.querySelector( '#magic' );
      this.scene = new THREE.Scene();
      this.createCamera();
      this.createRenderer();
      this.setup()
      this.bindEvents();
    }
  
    bindEvents(){
  
      window.addEventListener( 'resize', this.onWindowResize.bind( this ));
      
    }

    changeText(value) {
        this.createParticles.changeText(value)
    }
  
    setup(){ 
  
      this.createParticles = new CreateParticles( this.scene, this.font, this.particle, this.camera, this.renderer, this.message );
    }
  
    render() {
      
       this.createParticles.render()
       this.renderer.render( this.scene, this.camera )
    }
  
    createCamera() {
  
      this.camera = new THREE.PerspectiveCamera( 65, this.container.clientWidth /  this.container.clientHeight, 1, 10000 );
      this.camera.position.set( 0,0, 100 );
  
    }
  
    createRenderer() {
  
      this.renderer = new THREE.WebGLRenderer();
      this.renderer.setSize( this.container.clientWidth, this.container.clientHeight );
  
      this.renderer.setPixelRatio( Math.min( window.devicePixelRatio, 2));
  
      this.renderer.outputEncoding = THREE.sRGBEncoding;
      this.container.appendChild( this.renderer.domElement );
  
      this.renderer.setAnimationLoop(() => { this.render() })
  
    }
  
    onWindowResize(){
  
      this.camera.aspect = this.container.clientWidth / this.container.clientHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize( this.container.clientWidth, this.container.clientHeight );
  
    }
  }
  